<template>
    <div style="display:none">
        <audio
            v-if="!this.$store.getters.forceOffline"
            ref="alertAudio"
            :src="alarmSource"
            type="audio/mpeg"
            loop
            mute
        />
        <span>{{ alertsAudioOn }}</span>
    </div>
</template>
<script>
import webtmsBackend from '../../services/webtmsBackend';
import {isTruthy} from '@/utils/isTruthy';

const GET_TICKET_ALERTS_INTERVAL = 60000;

export default {
    name: 'TicketAlertsAudio',
    data() {
        return {
            LATEST_ALERT_DATE_ALARMED: new Date(0)
        };
    },
    computed: {
        ticketAlertsEnabledForCompany() {
            const companyPermissions = this.$store.getters.companyPermissions;
            return companyPermissions.some((element) => {
                return element.permission === 'TICKET_ALERTS' && element.granted == 1;
            });
        },
        ticketAlertsEnabledForUser() {
            const userOptions = this.$store.getters.userOptions;
            const alarmEnabledOption = userOptions.find(element => element.option === 'UI:alarm-enabled');
            return isTruthy(alarmEnabledOption?.value);
        },
        alarmSource() {
            const userOptions = this.$store.getters.userOptions;
            let alarmWhichOption = userOptions.find(element => element.option === 'UI:alarm-which');
            if (!alarmWhichOption) alarmWhichOption={value: '1'};
            return `WebTMS_alarm${alarmWhichOption?.value}.mp3`;
        },
        alertsAudioOn() {
            if(this.$store.getters.alertsAudioOn) {
                try {
                    this.$refs.alertAudio?.play();
                } catch(err) {
                    console.error('Note: failed to play() audio: ' + err?.message);
                }
            } else {
                try {
                    this.$refs.alertAudio?.pause();
                } catch(err) {
                    console.error('Note: failed to pause() audio: ' + err?.message);
                }
            }
            return this.$store.getters.alertsAudioOn;
        }
    },
    created() {
        this.getTicketAlerts();
    },
    methods:{
        async START_ALARMING() {
            try {
                // console.log('<< ALERT >> START_ALARMING');
                this.$store.commit('SET_ALERTS_AUDIO_ON', true);
                await this.$refs.alertAudio?.play();
            } catch(error) {
                // Most likely due to: DOMException: play() failed because the user didn't
                // interact with the document first.
                console.error('Audio Alarm could not play due to error: ', error);
            }
        },
        async STOP_ALARMING() {
            // console.log('<< ALERT >> STOP_ALARMING');
            this.$store.commit('SET_ALERTS_AUDIO_ON', false);
            await this.$refs.alertAudio?.pause();
        },
        async getTicketAlerts () {
            try {
                if(this.ticketAlertsEnabledForCompany && this.$store.getters.isLoggedIn ) {
                    if(!this.$store.getters.forceOffline) {
                        let ticketAlerts = await webtmsBackend.getTicketAlerts();
                        if(!ticketAlerts) {
                            ticketAlerts = [];
                        }
                        if(ticketAlerts && ticketAlerts.length) {
                            // get max(alert_date) for items in array
                            let maxAlertDate = new Date(Date.parse(ticketAlerts[0].alert_date));
                            for(let i = 1; i < ticketAlerts.length; i++) {
                                let itemAlertDate = new Date(Date.parse(ticketAlerts[i].alert_date));
                                if(itemAlertDate > maxAlertDate) {
                                    maxAlertDate = itemAlertDate;
                                }
                            }
                            // console.log('ALERT (1/3) maxAlertDate', maxAlertDate);
                            this.$store.commit('SET_TICKET_ALERTS', ticketAlerts);
                            let bTriggerAlarm = true;
                            const userOptions = this.$store.getters.userOptions;
                            let alarmWhenOption = userOptions.find(element => element.option === 'UI:alarm-when') || ({ option: 'UI:alarm-when', value: 'NEW' });
                            // console.log('ALERT (2/3) alarmWhenOption: ', alarmWhenOption.value); // (valid .value) equ "NEW" | "ALWAYS"
                            if(alarmWhenOption.value === 'NEW') {
                                // only alarm if an alert has a newer alert_date
                                if(maxAlertDate > this.LATEST_ALERT_DATE_ALARMED) {
                                    // console.log('ALERT (3/3) We have NEW Alerts');
                                    this.LATEST_ALERT_DATE_ALARMED = maxAlertDate;
                                } else {
                                    // console.log('ALERT (3/3) No NEW Alerts');
                                    bTriggerAlarm = false;
                                    await this.STOP_ALARMING();
                                }
                            } 
                            // else {
                            //     console.log('ALERT (3/3) ALWAYS Alert');
                            // }
                            if(!this.ticketAlertsEnabledForUser) {
                                bTriggerAlarm = false;
                            }
                            if(bTriggerAlarm) {
                                await this.START_ALARMING();
                            }
                        } else {
                            // console.log('ALERT: no ticket alerts');
                            this.$store.commit('SET_TICKET_ALERTS', []);
                            await this.STOP_ALARMING();
                        }
                    }
                }
            } catch(error) {
                console.error('!!!! Ticket Alerts Exception', error);
            } finally {
                const randomDelay = Math.floor(Math.random() * 30000);
                setTimeout(this.getTicketAlerts, GET_TICKET_ALERTS_INTERVAL + randomDelay);
            }
        } 
    } // methods
};
</script>